import type React from 'react';
import { createRoot } from 'react-dom/client';

export const renderRootForContainerId = (
  id: string,
  component: React.ReactElement,
) => {
  const container = document.getElementById(id);

  if (!container) {
    console.error(`container not found for ${id}`);
    return;
  }

  const root = createRoot(container);
  root.render(component);
};
